<div class="ms-0 mb-3 row">
    <ng-container>
        <span class="ps-0 pb-2" translate="Settings.OrganisationBrandingSection.BrandingColours.BasicColours"><app-info-button labelName="Settings.OrganisationBrandingSection.BasisColoursTooltip"></app-info-button></span>

        <ul class="list-group mb-2">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol"><span translate="Settings.OrganisationBrandingSection.BrandingColours.ElementFont"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.RGB"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.HEX"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Preview"></span></div>
                    <div class="col-2"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(fontLightColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{fontLightColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="fontLightColour" name="fontLightColour" [(ngModel)]="fontLightColour" (change)="updateColours();" #fontLightColourPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="fontLightColourPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': fontLightColour }"></button>
                            <button type="button" (click)="fontLightColourPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('fontLightColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(fontDarkColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{fontDarkColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="fontDarkColour" name="fontDarkColour" [(ngModel)]="fontDarkColour" (change)="updateColours();" #fontDarkColourPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="fontDarkColourPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': fontDarkColour }"></button>
                            <button type="button" (click)="fontDarkColourPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('fontDarkColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <ul class="list-group mb-2">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol"><span translate="Settings.OrganisationBrandingSection.BrandingColours.ElementIdentity"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.RGB"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.HEX"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Preview"></span></div>
                    <div class="col-2"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.IdentityBackground"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(identityBackgroundColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{identityBackgroundColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="identityBackground" name="identityBackground" [(ngModel)]="identityBackgroundColour" (change)="updateColours();" #identityBackgroundPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="identityBackgroundPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': identityBackgroundColour }"></button>
                            <button type="button" (click)="identityBackgroundPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('identityBackgroundColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.IdentityFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="identityFontColourType" [(ngModel)]="identityFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
        </ul>

        <ul class="list-group mb-2">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol"><span translate="Settings.OrganisationBrandingSection.BrandingColours.ElementPlatform"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.RGB"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.HEX"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Preview"></span></div>
                    <div class="col-2"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.PlatformBackground"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(platformBackgroundColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{platformBackgroundColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="platformBackground" name="platformBackground" [(ngModel)]="platformBackgroundColour" (change)="updateColours();"  #platformBackgroundPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="platformBackgroundPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': platformBackgroundColour }"></button>
                            <button type="button" (click)="platformBackgroundPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('platformBackgroundColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Header"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(headerColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{headerColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="header" name="header" [(ngModel)]="headerColour" (change)="updateColours();" #headerPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="headerPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': headerColour }"></button>
                            <button type="button" (click)="headerPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('headerColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.HeaderFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="headerFontColourType" [(ngModel)]="headerFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Primary"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(primaryColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{primaryColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="primary" name="primary" [(ngModel)]="primaryColour" (change)="updateColours();" #primaryPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="primaryPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': primaryColour }"></button>
                            <button type="button" (click)="primaryPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('primaryColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.PrimaryHover"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(primaryHoverColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{primaryHoverColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="primaryHover" name="primaryHover" [(ngModel)]="primaryHoverColour" (change)="updateColours();" #primaryHoverPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="primaryHoverPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': primaryHoverColour }"></button>
                            <button type="button" (click)="primaryHoverPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('primaryHoverColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.PrimaryDisable"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(primaryDisabledColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{primaryDisabledColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="primaryDisable" name="primaryDisable" [(ngModel)]="primaryDisabledColour" (change)="updateColours();" #PrimaryDisablePicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="PrimaryDisablePicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': primaryDisabledColour }"></button>
                            <button type="button" (click)="PrimaryDisablePicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('primaryDisabledColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.PrimaryFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="primaryFontColourType" [(ngModel)]="primaryFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
        </ul>

        <ul class="list-group mb-2">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol"><span translate="Settings.OrganisationBrandingSection.BrandingColours.ElementEmail"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.RGB"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.HEX"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Preview"></span></div>
                    <div class="col-2"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.EmailButton"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(emailButtonColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{emailButtonColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="emailButtonColour" name="emailButtonColour" [(ngModel)]="emailButtonColour" (change)="updateColours();" #emailButtonColourPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="emailButtonColourPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': emailButtonColour }"></button>
                            <button type="button" (click)="emailButtonColourPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('emailButtonColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.EmailButtonFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="emailButtonFontColourType" [(ngModel)]="emailButtonFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
        </ul>
    </ng-container>

    <div class="p-0 pt-4">
        <span class="pt-5 col-12" translate="Settings.OrganisationBrandingSection.BrandingColours.Options"></span>
        <div class="mb-3 mt-2 mx-0 p-1 col-12 row text-wrap border rounded lh-base">
            <div class="d-table form-check form-switch">
                <input class="switch-form-default form-check-input col-2" type="checkbox" role="switch" id="enableAdvancedColours" name="enableAdvancedColours" [(ngModel)]="showAdvancedColours">
                <label class="form-check-label pt-1 col-10" for="enableAdvancedColours" translate="Settings.OrganisationBrandingSection.BrandingColours.ShowAdvancedColours"><app-info-button labelName="Settings.OrganisationBrandingSection.AdvancedColoursTooltip"></app-info-button></label>
            </div>
        </div>
    </div>

    <ng-container *ngIf="showAdvancedColours">
        <span class="ps-0 pb-2" translate="Settings.OrganisationBrandingSection.BrandingColours.AdvancedColours"></span>
        <ul class="list-group">
            <li class="list-group-item subheader d-block">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol"><span translate="Settings.OrganisationBrandingSection.BrandingColours.ElementPlatform"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.RGB"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.HEX"></span></div>
                    <div class="col-2"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Preview"></span></div>
                    <div class="col-2"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Secondary"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(secondaryColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{secondaryColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="secondary" name="secondary" [(ngModel)]="secondaryColour" (change)="updateColours();" #secondaryPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="secondaryPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': secondaryColour }"></button>
                            <button type="button" (click)="secondaryPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('secondaryColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.SecondaryHover"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(secondaryHoverColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{secondaryHoverColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="secondaryHover" name="secondaryHover" [(ngModel)]="secondaryHoverColour" (change)="updateColours();" #secondaryHoverPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="secondaryHoverPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': secondaryHoverColour }"></button>
                            <button type="button" (click)="secondaryHoverPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('secondaryHoverColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.SecondaryDisable"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(secondaryDisabledColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{secondaryDisabledColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="secondaryDisable" name="secondaryDisable" [(ngModel)]="secondaryDisabledColour" (change)="updateColours();" #secondaryDisablePicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="secondaryDisablePicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': secondaryDisabledColour }"></button>
                            <button type="button" (click)="secondaryDisablePicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('secondaryDisabledColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.SecondaryFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="secondaryFontColourType" [(ngModel)]="secondaryFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Success"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(successColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{successColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="success" name="success" [(ngModel)]="successColour" (change)="updateColours();" #successPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="successPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': successColour }"></button>
                            <button type="button" (click)="successPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('successColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.SuccessHover"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(successHoverColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{successHoverColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="successHover" name="successHover" [(ngModel)]="successHoverColour" (change)="updateColours();" #successHoverPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="successHoverPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': successHoverColour }"></button>
                            <button type="button" (click)="successHoverPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('successHoverColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.SuccessDisable"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(successDisabledColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{successDisabledColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="successDisabled" name="successDisabled" [(ngModel)]="successDisabledColour" (change)="updateColours();"  #successDisabledPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="successDisabledPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': successDisabledColour }"></button>
                            <button type="button" (click)="successDisabledPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('successDisabledColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.SuccessFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="successFontColourType" [(ngModel)]="successFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Warning"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(warningColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{warningColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="warning" name="warning" [(ngModel)]="warningColour" (change)="updateColours();" #warningPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="warningPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': warningColour }"></button>
                            <button type="button" (click)="warningPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('warningColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.WarningHover"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(warningHoverColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{warningHoverColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="warningHover" name="warningHover" [(ngModel)]="warningHoverColour" (change)="updateColours();" #warningHoverPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="warningHoverPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': warningHoverColour }"></button>
                            <button type="button" (click)="warningHoverPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('warningHoverColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.WarningDisable"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(warningDisabledColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{warningDisabledColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="warningDisabled" name="warningDisabled" [(ngModel)]="warningDisabledColour" (change)="updateColours();" #warningDisabledPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="warningDisabledPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': warningDisabledColour }"></button>
                            <button type="button" (click)="warningDisabledPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('warningDisabledColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.WarningFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="warningFontColourType" [(ngModel)]="warningFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Danger"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(dangerColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{dangerColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="danger" name="danger" [(ngModel)]="dangerColour" (change)="updateColours();" #dangerPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="dangerPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': dangerColour }"></button>
                            <button type="button" (click)="dangerPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('dangerColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.DangerHover"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(dangerHoverColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{dangerHoverColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="dangerHover" name="dangerHover" [(ngModel)]="dangerHoverColour" (change)="updateColours();" #dangerHoverPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="dangerHoverPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': dangerHoverColour }"></button>
                            <button type="button" (click)="dangerHoverPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('dangerHoverColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.DangerDisable"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(dangerDisabledColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{dangerDisabledColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="dangerDisabled" name="dangerDisabled" [(ngModel)]="dangerDisabledColour" (change)="updateColours();" #dangerDisabledPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="dangerDisabledPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': dangerDisabledColour }"></button>
                            <button type="button" (click)="dangerDisabledPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('dangerDisabledColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.DangerFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="dangerFontColourType" [(ngModel)]="dangerFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.Info"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(infoColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{infoColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="info" name="info" [(ngModel)]="infoColour" (change)="updateColours();" #infoPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="infoPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': infoColour }"></button>
                            <button type="button" (click)="infoPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('infoColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.InfoHover"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(infoHoverColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{infoHoverColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="infoHover" name="infoHover" [(ngModel)]="infoHoverColour" (change)="updateColours();" #infoHoverPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="infoHoverPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': infoHoverColour }"></button>
                            <button type="button" (click)="infoHoverPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('infoHoverColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.InfoDisable"></span></div>
                    <div class="col-2 text-truncate"><span>{{hexToRgb(infoDisabledColour)}}</span></div>
                    <div class="col-2 text-truncate"><span>{{infoDisabledColour}}</span></div>
                    <div class="col-2 text-truncate">           
                        <input type="color" class="picker" id="infoDisabled" name="infoDisabled" [(ngModel)]="infoDisabledColour" (change)="updateColours();" #infoDisabledPicker />
                        <div class="btn-group colorpicker" role="group">
                            <button type="button" (click)="infoDisabledPicker.click()" class="btn btn-sm picker color" [ngStyle]="{'background-color': infoDisabledColour }"></button>
                            <button type="button" (click)="infoDisabledPicker.click()" class="btn btn-sm picker p-1"><i class="bi bi-eyedropper"></i></button>
                        </div>        
                    </div>
                    <div class="col-2 text-end">
                        <div *ngIf="allowReset" class="btn-group">
                            <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots bi-large"></i>
                            </button>
                            <ul class="dropdown-menu">
                            <li><a class="dropdown-item pt-1 pb-1" (click)="resetColour('infoDisabledColour')" translate="Settings.OrganisationBrandingSection.BrandingColours.Reset"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
            <li class="list-group-item d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-4 firstcol text-truncate"><span translate="Settings.OrganisationBrandingSection.BrandingColours.InfoFont"></span></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate"></div>
                    <div class="col-2 text-truncate">
                        <select name="infoFontColourType" [(ngModel)]="infoFontColourType" (change)="updateColours()" class="colorMode form-select">
                            <option value="light" translate="Settings.OrganisationBrandingSection.BrandingColours.Light"></option>
                            <option value="dark" translate="Settings.OrganisationBrandingSection.BrandingColours.Dark"></option>
                        </select>
                    </div>
                    <div class="col-2 text-end"></div>
                </div>
            </li>
        </ul>
    </ng-container>
</div>